import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { QuickLinksModule } from '@amfam/shared/ui/quick-links';
import { RiskListModule } from '@amfam/shared/ui/risk-list';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { ClaimsWrapperComponent } from './claims-wrapper/claims-wrapper.component';
import { FnolClaimComponent } from './fnol-claim/fnol-claim.component';
import { ReportClaimRiskSelectionComponent } from './report-claim-risk-selection/report-claim-risk-selection.component';

@NgModule({
  imports: [
    CommonModule,
    UiKitModule,
    FormsModule,
    ReactiveFormsModule,
    RiskListModule,
    SharedServicesModule,
    DsRouterLinkModule,
    QuickLinksModule
  ],
  declarations: [ReportClaimRiskSelectionComponent, FnolClaimComponent, ClaimsWrapperComponent],
  exports: [ReportClaimRiskSelectionComponent, FnolClaimComponent]
})
export class ClaimSharedRiskSelectionModule {}
